import Switch, { Page } from './Switch';

export { Switch as default, Page };
